export default __webpack_public_path__ + "static/media/Mr. Partha Sarathi Senapati.22643ad7.png";